import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=00d2c687&"
import script from "./InvoicesTable.vue?vue&type=script&lang=js&"
export * from "./InvoicesTable.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=00d2c687&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports